// extracted by css-extract-rspack-plugin
export default {"section":"L3y1V","content":"jnXhp"};